export default __webpack_public_path__ + "static/media/img04.9b10b2a1.jpg";